import {
  InMemoryCache,
  ApolloClient,
  HttpLink,
  ApolloLink,
  from,
} from '@apollo/client';

import config from '../../config';
import AuthService from '../auth/AuthService';

const httpLink = new HttpLink({ uri: config.backendUrl });

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext(({ headers = {} }) => {
    const token = AuthService.getToken();
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : null,
      },
    };
  });
  return forward(operation);
});

const i18nMiddleware = new ApolloLink((operation, forward) => {
  // add the i18n for backend calls to the headers
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      'accept-language': 'pt-BR',
    },
  }));
  return forward(operation);
});

const apolloClient = new ApolloClient({
  cache: new InMemoryCache({
    possibleTypes: {
      Error: [
        'NotFoundError',
        'InternalServerError',
        'BadRequestError',
        'UnauthorizedError',
        'ForbiddenError',
        'ConflictError',
        'UnprocessableEntityError',
      ],
    },
  }),
  link: from([authMiddleware, i18nMiddleware, httpLink]),
});

export default apolloClient;
